export default __webpack_public_path__ + "static/media/boosty_499.f84c6803.png";